import React from 'react';
import PropTypes from 'prop-types';
import './FilterBar.css';

/**
 * Toolbar / filter row for tables and queues.
 * layout: row (default toolbar) | stack (sidebar filter fields)
 * Fold point for FilterPillGroup + ViewControlsBar compositions.
 */
export function FilterBar({
  children,
  leading,
  trailing,
  density = 'comfortable',
  layout = 'row',
  className = '',
  ...props
}) {
  return (
    <div
      className={[
        'onyx-filter-bar',
        density !== 'comfortable' ? `onyx-filter-bar--${density}` : '',
        layout !== 'row' ? `onyx-filter-bar--${layout}` : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-filter-bar"
      data-density={density}
      data-layout={layout}
      role="toolbar"
      {...props}
    >
      {leading ? <div className="onyx-filter-bar__leading">{leading}</div> : null}
      <div className="onyx-filter-bar__main">{children}</div>
      {trailing ? <div className="onyx-filter-bar__trailing">{trailing}</div> : null}
    </div>
  );
}

FilterBar.propTypes = {
  children: PropTypes.node,
  leading: PropTypes.node,
  trailing: PropTypes.node,
  density: PropTypes.oneOf(['comfortable', 'compact']),
  layout: PropTypes.oneOf(['row', 'stack']),
  className: PropTypes.string,
};

/** Alias used by operator surfaces */
export const Toolbar = FilterBar;

export default FilterBar;
